// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
//action - user reducer
export const SET_USER = '@user/SET_USER';
export const REMOVE_USER = '@user/REMOVE_USER';
//action - notification reducer
export const SET_NOTIFICATION = '@notification/SET_NOTIFICATION';
export const CLEAR_NOTIFICATION = '@notification/CLEAR_NOTIFICATION';
